module.exports = __webpack_public_path__ + "static/index_image_3-65ec87d49868029735bea91237c77d37.jpg";